export default {
    DIALOG_OPENED: 'wildix/dialog_opened',
    DIALOG_CLOSED: 'wildix/dialog_closed',
    OPEN_DEVICE_SELECT_DROPDOWN: 'wildix/wizy/open_device_select_dropdown',
    CLOSE_DEVICE_SELECT_DROPDOWN: 'wildix/wizy/close_device_select_dropdown',
    REMOTE_VIDEO_CREATED: 'wildix/wizy/remote_video_created',
    REMOTE_VIDEO_DESTROYED: 'wildix/wizy/remote_video_destroyed',
    UPDATE_LOCAL_VIDEO: 'wildix/update_local_video',
    VISITOR_MODE: 'wildix/visitor_mode',
    UPDATE_TOGGLE_BUTTON: 'wildix/update_toggle_button',
    VISIBLE_PARTICIPANT_LIST: 'wildix/visible_participant_list',
    REMOTE_PARTICIPANT: 'wildix/remote_participant',
    PRIVATE_MESSAGE: 'wildix/private_message',
};
